import { inject } from '@angular/core';
import { AuthService, UserStatus } from './auth.service';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

export const adminGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  
  const auth = inject(AuthService);
  const router = inject(Router);

  const timeout = new Promise((_, reject) => setTimeout(() => reject('Timeout'), 5000));
  
  try {
    await Promise.race([auth.isInitialized, timeout]);
    const userStatus = auth.userStatus;
    if ( userStatus == UserStatus.ADMIN || userStatus == UserStatus.SUPER )
      return true;
  } catch (error) {
    console.error('Error initializing auth service', error);
  }
    
  return router.createUrlTree(['/login']);
};
